/**
 * Утилиты для создания "отпечатков" данных
 * Используются для определения изменений в карточках заказов/маршрутов
 * при умном обновлении Dashboard
 */
/**
 * Создаёт отпечаток заказа для сравнения
 * Включает только изменяемые поля (не включает id, orderNumber)
 */
export const createOrderFingerprint = (order) => {
    return JSON.stringify({
        status: order.status,
        scheduledDate: order.scheduledDate?.toISOString() ?? null,
        chargeLevel: order.chargeLevel,
        chargeValue: order.chargeValue,
        address: order.addressInfo?.getAddress() ?? null,
        latitude: order.addressInfo?.getLatitude() ?? null,
        longitude: order.addressInfo?.getLongitude() ?? null,
    });
};
/**
 * Создаёт отпечаток маршрута для сравнения
 * Включает поля, которые могут измениться при выполнении маршрута
 */
export const createRouteFingerprint = (route) => {
    return JSON.stringify({
        routeStatus: route.routeStatus,
        progressPercent: route.progressPercent,
        delayMinutes: route.delayMinutes,
        actualStartTime: route.actualStartTime,
        actualEndTime: route.actualEndTime,
        expectedEndTime: route.expectedEndTime,
        currentPoint: route.currentPoint
            ? {
                status: route.currentPoint.status,
                orderIndex: route.currentPoint.orderIndex,
                delayMinutes: route.currentPoint.delayMinutes,
            }
            : null,
        routePoints: route.routePoints.map((p) => ({
            actualArrivalTime: p.actualArrivalTime,
            actualDepartureTime: p.actualDepartureTime,
            isCompleted: p.isCompleted,
        })),
    });
};
